'use strict'; // https://www.ecma-international.org/ecma-262/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
  return typeof argument === 'string' || typeof argument === 'symbol';
};